export default {
  maintenance: {
    title: 'Scheduled Maintenance',
    governance: 'Governance Proposal',
    subscribe: 'Subscribe for Alerts',
    subscribeDescription: 'Get real-time notifications via Notifi',
    governanceDescription: 'Check details on the latest chain upgrade',
    footer:
      "We're making Helix better. We appreciate your patience and will be back soon!",
    description:
      "We're carrying out a few updates. During this time, some features will be unavailable for a little while."
  }
}
